import React, { useState } from 'react';
import SignatureField from '../SignatureField';

const OptInToggle = ({ 
    mode, 
    onModeChange, 
    signature, 
    onSignatureChange, 
    email, 
    required = false 
}) => {
    const handleToggle = (newMode) => {
        onModeChange(newMode);
    };

    return (
        <div className="optin-toggle-container">
            <label className="optin-toggle-label">
                Opt-In {required && '*'}
            </label>
            
            <div className="optin-toggle-buttons">
                <button
                    type="button"
                    onClick={() => handleToggle('signature')}
                    className={`button-28 ${mode === 'signature' ? 'selected' : ''}`}
                >
                    <div className="optin-toggle-radio">
                        {mode === 'signature' && <div className="optin-toggle-radio-dot"></div>}
                    </div>
                    <span>Unterschrift</span>
                </button>

                <button
                    type="button"
                    onClick={() => handleToggle('email')}
                    className={`button-28 ${mode === 'email' ? 'selected' : ''}`}
                >
                    <div className="optin-toggle-radio">
                        {mode === 'email' && <div className="optin-toggle-radio-dot"></div>}
                    </div>
                    <span>E-Mail</span>
                </button>
                
            </div>

            {mode === 'email' && (
                <div className="optin-toggle-info">
                    <p>Eine Opt-In E-Mail wird nach dem Bestätigen an den Kunden gesendet.</p>
                </div>
            )}

            {mode === 'signature' && (
                <div className="optin-toggle-signature">
                    <SignatureField
                        value={signature}
                        onChange={onSignatureChange}
                        label="Kundenunterschrift"
                        required={required}
                    />
                </div>
            )}
        </div>
    );
};

export default OptInToggle; 